import { render, staticRenderFns } from "./IdeaHomeCard.vue?vue&type=template&id=dac68c96&scoped=true"
import script from "./IdeaHomeCard.vue?vue&type=script&lang=js"
export * from "./IdeaHomeCard.vue?vue&type=script&lang=js"
import style0 from "./IdeaHomeCard.vue?vue&type=style&index=0&id=dac68c96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac68c96",
  null
  
)

export default component.exports